import { gql } from "@apollo/client"; // saveVisitaDisfagia.js

import { adaptListaIndicacion } from "../../../../Pages/MisVisitasCreation/utils/adaptSubModelsInput";

const SAVE_VISITA_DISFAGIA = gql`
  mutation saveVisitaDisfagia($input: AddVisitaDisfagiaInput!) {
    saveVisitaDisfagia(input: $input) {
      idVisita
      idVisitaDisfagia
    }
  }
`;

export default SAVE_VISITA_DISFAGIA;

export const adaptAddVisitaDisfagiaInput = (data) => ({
  idVisitaDisfagia: data?.idVisitaDisfagia,
  videodeglucion: !!data?.videodeglucion,
  disfagias: data?.disfagias,
  neumonia: !!data?.neumonia,
  alimentos: data?.alimentos,
  hidrataciones: data?.hidrataciones,
  traqueostomia: !!data?.traqueostomia,
  lucido: !!data?.lucido,
  compromisoMotor: !!data?.compromisoMotor,
  justificacionModificacion: data?.justificacionModificacion,
  formaPreparacion: data?.formaPreparacion,
  indicacionEspecial: data?.indicacionEspecial,
  hidratacion: !!data?.hidratacion,
  indicacionHidratacion: data?.indicacionHidratacion,
  proteinasTotales: data?.proteinasTotales,
  caloriasTotales: data?.caloriasTotales,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita
});